var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignItemsTopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 26.8888H4.33398V5.5555H12.334V26.8888ZM23.0007 5.5555H15.0007V18.8888H23.0007V5.5555ZM27.0007 0.222168H0.333984V2.88883H27.0007V0.222168Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignItemsTopIcon);
export default __webpack_public_path__ + "static/media/align-items-top-icon.28cf4573cbfc72fd079edbb6f0df2a8e.svg";
export { ForwardRef as ReactComponent };